import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import { VehicleIndemnityValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import { useGetVehicleIndemnityByIdQuery, useUpdateVehicleIndemnityMutation } from "AppQuries/master/VehicleIndeminty/vehicleindemnity";
import VehicleIndemnityForm from "Components/Form/VehicleIndemnityForm";
const EditVehicleIndemnity = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const {
    data: getVehicleIndemnityById,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetVehicleIndemnityByIdQuery(
    {
      companyCode: userData?.companyCode,
      code: code,
    },
    {
      enabled: !!code,
    }
  );
  const {
    mutate: updateVehicleIndemnity,
    isPending,
    isError,
    error,
  } = useUpdateVehicleIndemnityMutation();
  const methods = useForm({
    defaultValues: {
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    },
    resolver: yupResolver(VehicleIndemnityValidationSchema),
  });

  const { setValue } = methods;

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (payload) => {
    updateVehicleIndemnity(payload, {
      onSuccess: (data) => {
        if (data === true) {
          toast.success("Updated Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.vehicleindemnity}`);
          }, 1000);
        } else {
          toast.warning("Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  useEffect(() => {
    if (
      Array.isArray(getVehicleIndemnityById) &&
      getVehicleIndemnityById.length > 0
    ) {
      Object.keys(getVehicleIndemnityById[0]).forEach((key) => {
        setValue(key, getVehicleIndemnityById[0][key]);
      });
    }
  }, [getVehicleIndemnityById]);
  if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading || isPending) return <LoadingSpinner />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Edit Vehicle Indemnity</h4>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Update Vehicle Indemnity
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.master}${all_routes.vehicleindemnity}`}
                      className="btn btn-secondary"
                    >
             <i className="fas fa-reply me-2"></i>
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Edit Vehicle Indemnity</h4>
                    </div>
                    <div className="card-body">
                      <VehicleIndemnityForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditVehicleIndemnity;
